import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Pefive() {
  return (
    <>
      <div className="pe05">
        <img src="images/img-18.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Pefive;
